import styled from "styled-components";
import Box from "@mui/material/Box";
import { colors } from "healthex-common/colors";
import PeopleIcon from "@mui/icons-material/People";
import Typography from "@mui/material/Typography";
export const IconContainer = styled(Box) `
    display: flex;
    justify-content: center;
    align-items: center;
    width: 88px;
    height: 88px;
    border-radius: 50%;
    background-color: ${colors.blue_10};
`;
export const StyledPeopleIcon = styled(PeopleIcon) `
    color: #93b4d4;
    width: 40px;
    height: 40px;
`;
export const ContentWrapper = styled(Box) `
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    padding: 0 16px;
`;
export const MessageSection = styled(Box) `
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;
export const TitleText = styled(Typography) `
    font-size: 32px;
    font-weight: 500;
    line-height: 36px;
    color: ${({ theme }) => theme.palette.text.primary};
    text-align: center;
`;
export const SubtitleText = styled(Typography) `
    font-size: 16px;
    line-height: 24px;
    color: ${({ theme }) => theme.palette.text.secondary};
    text-align: center;
`;
export const AccountCardsWrapper = styled(Box) `
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
export const AccountCard = styled(Box) `
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px;
    padding-left: 0;
    border-radius: 12px;
    border: 1px solid ${colors.blue_30};
    background: ${({ isSelected }) => (isSelected ? colors.blue_10 : colors.white_background)};
    cursor: pointer;
    transition: all 0.2s ease;
    gap: 12px;
    min-height: 72px;

    &:hover {
        border-color: ${colors.blue_main};
    }
`;
export const AccountCardContent = styled(Box) `
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 2px;
`;
export const AccountEmail = styled(Typography) `
    font-size: 13px;
    font-weight: 400;
    line-height: normal;
    color: ${({ theme }) => theme.palette.text.primary};
`;
export const AccountDescription = styled(Typography) `
    font-size: 13px;
    font-weight: 400;
    line-height: normal;
    color: ${({ theme }) => theme.palette.text.secondary};
`;
export const AccountLastActive = styled(Typography) `
    font-size: 10px;
    font-weight: 400;
    line-height: normal;
    color: ${({ theme }) => theme.palette.text.secondary};
`;
export const SupportSection = styled(Box) `
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    width: 100%;
`;
export const SupportText = styled(Typography) `
    font-size: 13px;
    font-weight: 400;
    line-height: normal;
    color: ${({ theme }) => theme.palette.text.primary};
    text-align: center;
`;
export const SupportLink = styled.span `
    font-size: 13px;
    color: ${colors.blue_main};
    text-decoration: underline;
    cursor: pointer;
`;
export const SupportSubtext = styled(Typography) `
    font-size: 10px;
    font-weight: 400;
    line-height: normal;
    color: ${({ theme }) => theme.palette.text.secondary};
    text-align: center;
`;
export const ErrorText = styled(Typography) `
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.palette.error.main};
    text-align: center;
`;
export const ButtonWrapper = styled(Box) `
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px 32px;
    margin-top: 84px;
`;
